import { LoggerType } from "@dcl-ue/app-logger";
export interface ITransactEnvVariables {
  apigeeUrl: string;
  apigeeEnv: string;
  apigeeClientId: string;
  apigeeClientOrchestrationUrl: string;
  clientIdOrchestration: string;
  appId: string;
  createProposalEndpoint: string;
  simulateOrderEndpoint: string;
  cartManipulationEndpoint: string;
  promoCodeDetailsEndpoint: string;
  plansAndPricingEndpoint: string;
  cartItemDetailsEndpoint: string;
  leadServiceEndpoint: string;
  paymetricDecryptEndpoint: string;
  createOrderIdEndpoint: string;
  authorizeCreditCardEndpoint: string;
  countryEndpoint: string;
  splitAuthorizationKey: string;
  pricerType: string;
  loggerType: LoggerType;
  createCartUrl: string;
  repriceProductUrl: string;
  productPriceUrl: string;
  repriceCartUrl: string;
  addProductUrl: string;
  appDynamicsKey: string;
  salesForceValidationEndpoint: string;
  onepassCreateEndpoint: string;
  trialInitiationServiceEndpoint?: string;
  trialEntitlementServiceEndpoint?: string;
  stateEndpoint: string;
  onepassAuthenticateSignonTokenEndpoint?: string;
  onepassCreateTransferTokenEndpoint?: string;
  onepassFindProfileEndpoint: string;
  tncDecryptEndpoint: string;
  newCustomerLoaderPageLink: string;
  existingCustomerLoaderPageLink: string;
  liveChatSfUrl: string;
  liveChatSitePathUrl: string;
  liveChatOrgId: string;
  liveChatBaseLiveAgentContentUrl: string;
  liveChatDeploymentId: string;
  liveChatButtonId: string;
  liveChatBaseLiveAgentUrl: string;
  liveChatEswLiveAgentName: string;
  liveChatSrc: string;
  liveChatEswConfigDevName: string;
  liveChatIsOfflineSupportEnabled: "yes" | "no";
  freeTrialRedirectUrl: string;
  blocklistEndpoint: string;
  userInfoEndpoint: string;
  usersProfileEndpoint: string;
  refreshTokenEndpoint: string;
  loginTokenServletEndpoint: string;
  addressSuggestionEndpoint: string;
  loginTokenServletRegisterEndpoint: string;
  addonsEndpoint: string;
  addressSuggestionsEndpoint: string;
  defaultPracticalLawCampaignId: string;
  defaultWestlawCampaignId: string;
  defaultEloquaCid: string;
  DCPGetProductDescriptionEndpoint: string;
  productType: string;
  salesOrg: string;
}

const defaultEnvVariables = {
  apigeeUrl: "",
  apigeeEnv: "",
  apigeeClientId: "",
  apigeeClientOrchestrationUrl: "",
  clientIdOrchestration: "",
  appId: "",
  createProposalEndpoint: "",
  simulateOrderEndpoint: "",
  cartManipulationEndpoint: "",
  promoCodeDetailsEndpoint: "",
  plansAndPricingEndpoint: "",
  cartItemDetailsEndpoint: "",
  leadServiceEndpoint: "",
  paymetricDecryptEndpoint: "",
  createOrderIdEndpoint: "",
  authorizeCreditCardEndpoint: "",
  countryEndpoint: "",
  splitAuthorizationKey: "",
  pricerType: "client",
  createCartUrl: "",
  repriceProductUrl: "",
  productPriceUrl: "",
  repriceCartUrl: "",
  addProductUrl: "",
  loggerType: "client",
  appDynamicsKey: "",
  salesForceValidationEndpoint: "",
  onepassCreateEndpoint: "",
  trialInitiationServiceEndpoint: "",
  trialEntitlementServiceEndpoint: "",
  stateEndpoint: "",
  onepassAuthenticateSignonTokenEndpoint: "",
  onepassCreateTransferTokenEndpoint: "",
  onepassFindProfileEndpoint: "",
  tncDecryptEndpoint: "",
  newCustomerLoaderPageLink: "",
  existingCustomerLoaderPageLink: "",
  liveChatSfUrl: "",
  liveChatSitePathUrl: "",
  liveChatOrgId: "",
  liveChatBaseLiveAgentContentUrl: "",
  liveChatDeploymentId: "",
  liveChatButtonId: "",
  liveChatBaseLiveAgentUrl: "",
  liveChatEswLiveAgentName: "",
  liveChatSrc: "",
  liveChatEswConfigDevName: "",
  liveChatIsOfflineSupportEnabled: "no",
  freeTrialRedirectUrl: "",
  blocklistEndpoint: "",
  userInfoEndpoint: "",
  usersProfileEndpoint: "",
  refreshTokenEndpoint: "",
  loginTokenServletEndpoint: "",
  loginTokenServletRegisterEndpoint: "",
  addonsEndpoint: "",
  defaultPracticalLawCampaignId: "",
  defaultWestlawCampaignId: "",
  defaultEloquaCid: "",
  productType: "",
  salesOrg: "",
} as ITransactEnvVariables;

let envVariables: ITransactEnvVariables;

export const initEnvVariables = () => {
  const envConfigFromAEM = document.getElementById("env-config") as HTMLElement;
  const envConfigParsed = JSON.parse(
    envConfigFromAEM?.innerHTML ?? JSON.stringify(defaultEnvVariables)
  );

  envVariables = Object.assign({}, defaultEnvVariables, envConfigParsed);
};

export const getEnvVariables = () => {
  if (!envVariables) {
    initEnvVariables();
  }

  return envVariables;
};

export const getEnvVar = (key: keyof ITransactEnvVariables): string => {
  const envVars = getEnvVariables();

  return envVars[key] || "";
};
